<template>
  <div class="hello">

    <b-container>
        <b-row>
            <b-col>
                <b-input-group prepend="Email *" class="mt-3">
                    <b-form-input v-model="$v.email.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.email.emailvalidator">Please check this email address</p>

                <b-input-group prepend="Password *" class="mt-3">
                    <b-form-input type='password' v-model="$v.password1.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.password1.minLength">At least 8 characters</p>

                <b-input-group prepend="Re-enter Password *" class="mt-3">
                    <b-form-input type='password' v-model="$v.password2.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.password2.sameAsPassword">The passwords do not match.</p>

            </b-col>
        </b-row>

        <!-- Control buttons -->
        <b-row>
            <b-col>
                <b-button @click="previous">Previous</b-button>
                <b-button @click="next" :disabled="!formValid">Next</b-button>
            </b-col>
        </b-row>
        
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { required, minLength, between, sameAs } from 'vuelidate/lib/validators'
import { helpers } from 'vuelidate/lib/validators'

const emailvalidator = helpers.regex('emailvalidator',/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/)

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
    },

    data() {
        return {
            formValid:false,
            email:'',
            password1:'',
            password2:'',

        }
    },

    validations: {
        email: {
                required,
                emailvalidator,
        },
        password1: {
                required,
                minLength: minLength(8),
        },
        password2: {
                required,
                sameAsPassword: sameAs("password1")
        },

    },

    methods:{
        checkForm(){
            //console.log("Checking street: "+this.contactForm.street1)
            if((!this.$v.email.$invalid&&!this.$v.password1.$invalid&&!this.$v.password2.$invalid)) this.formValid=true
            else this.formValid=false
        },

        next(){
            this.saveInfoToStore
            this.$emit('next', {value: true});

        },
        previous(){
            this.saveInfoToStore
            this.$emit('previous', {value: true});

        },
        saveInfoToStore(){
            this.$store.commit('setNewUserEmail', this.email)

        },
    },

    mounted(){
    },
}
</script>

<style scoped>
.error {
  color: red;
  font-size:12px;
}

</style>

